export default __webpack_public_path__ + "static/media/01.5c2a5e34.webp";